"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactQuery = require("react-query");

var _request = require("@nicbase/request");

var _queryKey = _interopRequireDefault(require("./queryKey"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var setAlarmActive = function setAlarmActive(portalId, alarmId, activationStatus) {
  return {
    type: 'SET_ALARM_ACTIVE_REQUEST',
    headers: {
      version: 'v1',
      portalId: portalId
    },
    body: {
      alarmId: alarmId,
      activationStatus: activationStatus
    }
  };
};

var usePortalAdminAlarmStatus = function usePortalAdminAlarmStatus(portalId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var queryClient = (0, _reactQuery.useQueryClient)();
  return (0, _reactQuery.useMutation)( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var alarmId, activationStatus, _yield$request, body;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              alarmId = _ref.alarmId, activationStatus = _ref.activationStatus;
              _context.next = 3;
              return request(setAlarmActive(portalId, alarmId, activationStatus));

            case 3:
              _yield$request = _context.sent;
              body = _yield$request.body;
              return _context.abrupt("return", body);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), _objectSpread({
    onMutate: function () {
      var _onMutate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(variables) {
        var passedAlarmId, newStatus;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                passedAlarmId = variables.alarmId, newStatus = variables.activationStatus;
                _context2.next = 3;
                return queryClient.cancelQueries(_toConsumableArray((0, _queryKey["default"])(portalId)));

              case 3:
                // optimistically update the toggled alarm
                queryClient.getQueryCache().findAll(_toConsumableArray((0, _queryKey["default"])(portalId))).forEach(function (query) {
                  var currentQueryKey = query.queryKey;
                  queryClient.setQueryData(currentQueryKey, function (oldData) {
                    var _oldData$pages;

                    return _objectSpread(_objectSpread({}, oldData), {}, {
                      pages: oldData === null || oldData === void 0 ? void 0 : (_oldData$pages = oldData.pages) === null || _oldData$pages === void 0 ? void 0 : _oldData$pages.map(function (page) {
                        var _page$alarms = page.alarms,
                            alarms = _page$alarms === void 0 ? [] : _page$alarms;
                        var index = alarms.findIndex(function (alarm) {
                          return alarm.id === passedAlarmId;
                        });

                        if (index >= 0) {
                          return _objectSpread(_objectSpread({}, page), {}, {
                            alarms: [].concat(_toConsumableArray(alarms.slice(0, index)), [_objectSpread(_objectSpread({}, alarms[index]), {}, {
                              active: newStatus
                            })], _toConsumableArray(alarms.slice(index + 1)))
                          });
                        }

                        return page;
                      })
                    });
                  });
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function onMutate(_x2) {
        return _onMutate.apply(this, arguments);
      }

      return onMutate;
    }(),
    onError: function onError(_, variables) {
      var passedAlarmId = variables.alarmId,
          newStatus = variables.activationStatus; // revert changes on error

      queryClient.getQueryCache().findAll(_toConsumableArray((0, _queryKey["default"])(portalId))).forEach(function (query) {
        var currentQueryKey = query.queryKey;
        queryClient.setQueryData(currentQueryKey, function (oldData) {
          return _objectSpread(_objectSpread({}, oldData), {}, {
            pages: oldData.pages.map(function (page) {
              var _page$alarms2 = page.alarms,
                  alarms = _page$alarms2 === void 0 ? [] : _page$alarms2;
              var index = alarms.findIndex(function (alarm) {
                return alarm.id === passedAlarmId;
              });

              if (index >= 0) {
                return _objectSpread(_objectSpread({}, page), {}, {
                  alarms: [].concat(_toConsumableArray(alarms.slice(0, index)), [_objectSpread(_objectSpread({}, alarms[index]), {}, {
                    active: !newStatus
                  })], _toConsumableArray(alarms.slice(index + 1)))
                });
              }

              return page;
            })
          });
        });
      });
    }
  }, options));
};

var _default = usePortalAdminAlarmStatus;
exports["default"] = _default;